import React , { useState } from 'react'
import Slider from "react-slick";

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import "./homePage.css"

import HeroSection from '../../components/heroSection'
import NetworkSection from '../../components/networkSection'
import BottomSection from '../../components/bottomSection'
import BottomSheet from '../../components/bottomSheet'


const HomePage = () => {
  const [sliderRef, setSliderRef] = useState(null)


  return (

<>

<HeroSection/>
<NetworkSection/>
<BottomSection/>

<BottomSheet/>
</>
  )
}

export default HomePage